"use strict";

const {
  default: I18NextDelegate
} = require('./I18NextDelegate');
const {
  default: Factory
} = require('./Factory');
const VERSION = require('../package.json').version;
let GLOBAL = {};
if (typeof window === 'object') {
  GLOBAL = window;
} else if (typeof global === 'object') {
  GLOBAL = global;
}
if (GLOBAL.leveregeI18N) {
  const version = GLOBAL.leveregeI18N.version;
  // eslint-disable-next-line no-console
  console.log(`Version ${VERSION} of @leverege/i18n library found another installed verison: ${version}`);
  module.exports = GLOBAL.leveregeI18N.library;
} else {
  Factory.defaultObject = I18NextDelegate;
  const I18N = require('./I18N').default;
  module.exports = new I18N();
  GLOBAL.leveregeI18N = {
    version: VERSION,
    library: module.exports
  };
}